/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import Styles from './styles.module.sass'
import { FaRegFile } from 'react-icons/fa'
import { BiTrashAlt } from 'react-icons/bi'
import { formatBytes } from './handlers'
import { Flex, useBreakpointValue } from '@chakra-ui/react'
import { useResponsive } from '@/hooks/useResponsive'

const FileInfo = ({ onDeleteFile, fileName, fileSize }) => {
  const iconStyle = { color: '#5a5a5a' }
  const { flexGap } = useResponsive()
  const alignItems = useBreakpointValue({
    base: 'center',
    sm: ''
  })
  const flexDirection = {
    base: 'column',
    sm: 'row'
  }
  return (
    <>
      { fileName !== '' && fileSize !== '' &&
        <Flex
          className={Styles.fileContainer}
          flexDirection={flexDirection}
          gap={flexGap}
          alignItems={alignItems}
        >
          <Flex
            gap={flexGap}
            flexDirection={flexDirection}
            alignItems={alignItems}
          >
            <FaRegFile
              size="30"
              className="shrink-0"
            />
            <div>
              <p className="has-text-weight-semibold">{fileName}</p>
              <p>{formatBytes(fileSize)}</p>
            </div>
          </Flex>
          <div className={Styles.iconTrashContainer}>
            <button
              onClick={onDeleteFile}
              className={`${Styles.deleteButton} has-tooltip-top`}
              data-tooltip="Delete"
            >
              <BiTrashAlt { ...iconStyle }/>
            </button>
          </div>
        </Flex>
      }
    </>
  )
}

export default FileInfo
